import React, { useContext } from 'react';

import { AmpPropsContext } from '../../context/amp-props/amp-props-provider';
import { IAmpPropsTag } from '../../typings/amp';
import { getAmpTag } from '../../utils/amp';
import { IClassNames, makeClassNames } from '../../utils/styles';
import AmpImg from '../amp/amp-img';
import './event-icon.scss';
import { LbEventType } from '../../configs/events';

export interface IEventIcon {
  icon?: string;
  borderColor?: string;
  backgroundColor?: string;
  style?: React.CSSProperties;
  type?: LbEventType;
}

const classNames = (isSkyPost?: boolean): IClassNames =>
  makeClassNames({
    EventIcon: ['event-icon', isSkyPost && 'event-icon--sky-post'],
  });

const EventIcon: React.FC<IEventIcon> = ({ icon, borderColor, backgroundColor, style, type }) => {
  const isSkyPost = type === LbEventType.SKY_POST;
  const cn = classNames(isSkyPost);
  const { ampProps } = useContext(AmpPropsContext);
  const ampImg: IAmpPropsTag | undefined = getAmpTag(ampProps, 'img-icon');

  return (
    <div className={cn.EventIcon} style={{ borderColor, backgroundColor, ...style }}>
      {ampImg ? (
        <AmpImg src={icon} alt="" layout={ampImg.layout} width={ampImg.width} height={ampImg.height} />
      ) : (
        <img src={icon} alt="" loading="lazy" />
      )}
    </div>
  );
};

export default EventIcon;
